/* Native details stays keyboard-accessible; event delegation supports theme-editor reloads. */
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ocean-all-menu[open]').forEach(function (menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
document.addEventListener('click', function (event) {
  document.querySelectorAll('.ocean-all-menu[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
